module.exports = require('./assignIn');



//////////////////
// WEBPACK FOOTER
// ./~/lodash/extend.js
// module id = 1075
// module chunks = 0 1